import Image from "next/image";
import { useWebTranslation } from "translations";
import { Typography } from "ui-kit/Typography";
import { SpeciesEnum } from "../../../../../../__generated__/globalTypes";
import styles from "./ThankYouBanner.module.css";

export const ThankYouBanner = ({
  species,
}: {
  species: SpeciesEnum | null;
}) => {
  const { t } = useWebTranslation();
  const { i18n } = useWebTranslation();

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Typography
          style={{ textTransform: "uppercase" }}
          variant="body3"
          color="navy500"
        >
          <strong>{t("tractive.thankyou.highlight")}</strong>
        </Typography>
        <Typography variant="body1">
          <strong>{t("tractive.thankyou.title")}</strong>
        </Typography>
        <Typography variant="body2" color="grey500">
          {t("tractive.thankyou.description")}
        </Typography>
      </div>
      <div className={styles.image}>
        <Image
          src={`/images/tractive/banner-${species}-${i18n?.language}.png`}
          alt=""
          width={284}
          height={228}
          className={styles.image}
        />
      </div>
    </div>
  );
};
